<template>
    <v-list-tile>
        <v-dialog v-model="mostrarDialogoExportar" persistent :max-width="Modal.Confirmacao.larguraMaxima">
            <v-list-tile-title slot="activator">
                <i class="fas fa-share mr-2" aria-hidden="true"/>
                Exportar Resultado
            </v-list-tile-title>
            <mensagem-confirmacao v-if="!resultadoExportado" :exibirMensagem="mostrarDialogoExportar"
                                  titulo="Exportar Resultado"
                                  textoSecundario="Deseja realmente exportar o resultado da compra direta?"
                                  tamanhoMaximo="320"
                                  @confirmado="exportarCompraDireta"
                                  @recusado="mostrarDialogoExportar = false"/>

            <mensagem-alerta v-else :exibirMensagem="mostrarDialogoExportar"
                              titulo="Alerta exportação"
                              textoPrimario="⚠️ Atenção !!!"
                              textoSecundario="Resultado já exportado. <br/>Para uma nova exportação, é necessário que haja alterações no resultado da compra."
                              com-botao-confirmar
                              botaoConfirmar="OK"
                              @confirmado="mostrarDialogoExportar = false"/>
        </v-dialog>
    </v-list-tile>
</template>

<script>
import MensagemAlerta from '@/views/components/MensagemAlerta'
import MensagemConfirmacao from '@/views/components/MensagemConfirmacao'
import {Modal} from '@/core/constants'
export default {
    name: 'AcoesExportarResultado',
    components:{MensagemConfirmacao, MensagemAlerta},
    props:['resultadoExportado'],
    data() {
        return {
            mostrarDialogoExportar: false,
            Modal
        }
    },
    methods: {
        exportarCompraDireta() {
            this.mostrarDialogoExportar = false
            this.$emit('exportarResultado')
        }
    }
}
</script>

<style scoped lang="stylus">
    .v-dialog__container
        width 100%
</style>
